<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="">Copyright © 2025 <a target="_blank" href="https://copexcontractors.co.tz/">copex contractors</a>, All rights reserved.</p>
        </div>
  
    </div>
    <!-- END FOOTER -->
</template>
